import React            from 'react';
import TimelineActivity from '~/components/drawers/timeline/activity';

const TimelineActivityCandidateRemoved = ({
  icon = 'briefcase',
  prefix = 'far',
  color = 'text-grey-dark',
  title = (obj) => {
    const { activity } = obj.props;
    const {
      job_title, location, removed_by, name = 'Candidate',
    } = activity.parameters || {};

    return (
      `${name} was removed${removed_by ? ` by ${removed_by}` : ''} from ${job_title} Job${location ? ` in ${location}` : ''}`
    );
  },
  ...props
}) => <TimelineActivity {...props} icon={icon} prefix={prefix} color={color} title={title} />;

export default TimelineActivityCandidateRemoved;
